export default [
    {
        // [0]
        key: "code",
        label: app.$i18n.t("Personal"),
        stickyColumn: true,
        visible: true,
        sortable: true,
    },
    {
        // [1]
        key: "ut_type",
        label: "UT Type",
        visible: true,
    },
    {
        // [2]
        key: "personal_type",
        label: app.$i18n.t("PERSONAL TYPE"),
        visible: false,
    },
    {
        // [3]
        key: "status",
        label: app.$i18n.t("STATUS"),
        visible: true,
        thClass: "text-center",
        tdClass: "text-center"
    },
    {
        // [4]
        key: "is_viatic",
        label: app.$i18n.t("VIATIC"),
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
    },
    {
        // [5]
        key: "coordinator",
        label: app.$i18n.t("COORDINATOR"),
        visible: false,
    },
    {
        // [6]
        key: "entity_group_name",
        label: app.$i18n.t("Entity Group"),
        visible: true,
    },
    {
        // [7]
        key: "attendance_status",
        label: app.$i18n.t("ATTENDANCE STATUS"),
        visible: true,
        tdClass: "text-center"
    },
    {
        // [8]
        key: "abbreviation",
        label: app.$i18n.t("ATTENDANCE"),
        visible: true,
    },
    {
        // [9]
        key: "observation",
        label: app.$i18n.t("OBSERVATION"),
        visible: true,
    },
    {
        // [10]
        key: "comment",
        label: app.$i18n.t("COMMENT"),
        visible: true,
    },
    {
        // [11]
        key: "created_by",
        label: app.$i18n.t("CREATED BY"),
        visible: true,
    },
]